import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../helpers/AuthContext";

const ScripturePlanningBridge = () => {
    const { isLoggedIn } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleContinue = () => {
        if (typeof window.gtag === "function") {
            window.gtag("event", "continue_planning", { source: "scripture_page" });
        }

        if (isLoggedIn) {
            navigate("/scripture/choose-passages");
        } else {
            navigate("/register/choose-your-plan");
        }
    };

    return (
        <div className="scripture-planning-bridge mt-5 pt-4" style={{ borderTop: "1px solid #e9ecef" }}>
            <p className="text-muted mb-1" style={{ fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                Planning a service?
            </p>
            <p className="mb-3">
                Many worship leaders use passages like this to anchor an entire service.
                {!isLoggedIn && " Create an account to build and save your worship service plans."}
            </p>
            <button className="btn btn-primary btn-sm" onClick={handleContinue}>
                {isLoggedIn ? "Start planning this service" : "Create an account to start planning"}
            </button>
        </div>
    );
};

export default ScripturePlanningBridge;
